import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UserService} from 'src/app/services/user.service';
import {ShoppingCartService} from '../../../../services/shopping-cart.service';
import {NgxSpinnerService} from 'ngx-spinner';


@Component({
  selector: 'app-payment-selection',
  templateUrl: './payment-selection.component.html',
  styleUrls: ['./payment-selection.component.css']
})
export class PaymentSelectionComponent implements OnInit {

  swishIntegration = false;
  paysonIntegration = false;
  stripeIntegration = false;
  paymentType:  PaymentType;

  constructor(public userService: UserService,
              private route: ActivatedRoute,
              private shoppingCartService: ShoppingCartService,
              private spinner: NgxSpinnerService
  ) {
    console.log('creating payment selection component');
    this.shoppingCartService.paymentAvailableEvent.subscribe(
      (data: boolean) => {
        if (data) {
          this.spinner.hide();
        } else {
          if (!data) {
            this.spinner.show();
          }
        }
      });
    if (shoppingCartService.gdpr && shoppingCartService.terms) {
      this.spinner.hide();
    } else {
      this.spinner.show();
    }

    this.shoppingCartService.priceChangedInbasket.subscribe(
      (data: boolean) => {
        if (data) {
          // invalidating payson previously sent request -IMPORTANT!
          this.shoppingCartService.paysonSnippet = '';
          this.shoppingCartService.paymentType = '';
          this.paymentType = null;
          this.ngOnInit();
        }
      });
  }

  ngOnInit() {
    if (this.shoppingCartService.gdpr && this.shoppingCartService.terms) {
      this.spinner.hide();
    } else {
      this.spinner.show();
    }
    console.log('on ngOnInit function');
    this.userService.fetchUser(this.route.snapshot.params['username'])
      .then(userDto => {
        // console.log(userDto.swishIntegration);
        this.swishIntegration = userDto.swishIntegration.valueOf();
        // console.log(userDto.paysonIntegration);
        this.paysonIntegration = userDto.paysonIntegration.valueOf();
        this.stripeIntegration = userDto.stripeIntegration.valueOf();
      });
    this.shoppingCartService.paymentType ? this.paymentType = PaymentType[this.shoppingCartService.paymentType] : this.paymentType = null;
  }
}

export enum PaymentType {
  SWISH = 'SWISH',
  PAYSON = 'PAYSON',
  STRIPE = 'STRIPE'
}
